<template>
  <div class="Wdgt-Auth-Module">
    <form class="Wdgt-Auth-Module__form" ref="form">
      <TextInput class="Wdgt-Auth-Module__form-field" :placeholder="'Имя пользователя'" :name="'username'"/>
      <PassInput class="Wdgt-Auth-Module__form-field" :placeholder="'Пароль'" :name="'password'"/>
      <p v-if="errorMessage" class="Wdgt-Auth-Module__error-txt">{{ errorMessage }}</p>
      <div class="Wdgt-Auth-Module__forgot-box">
        <button class="Wdgt-Auth-Module__lnk" @click="toOpenForgotPassSection">Забыли пароль?</button>
      </div>
      <CheckboxInput class="Wdgt-Auth-Module__remember-me" :label="'Запомнить меня'" :name="'remember'" />
      <ButtonMain class="Wdgt-Auth-Module__button" :width="'100%'" @click="toLogin" :loading="get_isLoading">Войти</ButtonMain>
      <p class="Wdgt-Auth-Module__ftr-txt">
        Нет аккаунта? <button class="Wdgt-Auth-Module__lnk" @click="toOpenSignupSection">Зарегистрироваться</button>
      </p>
    </form>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { setCookie } from '@shared/utils/auth';
  import { backendUrl } from "@shared/constants/urls/appUrls";
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
  //------------------------------
  import TextInput from '@shared/UI/Fields/TextInput/TextInput.vue';
  import PassInput from '@shared/UI/Fields/PassInput/PassInput.vue';
  import CheckboxInput from '@shared/UI/Fields/Checkbox/CheckboxInput.vue';
  import ButtonMain from '@shared/UI/Buttons/ButtonMain/ButtonMain.vue';
  //------------------------------
  const store = useStore();
  const router = useRouter();
  //------------------------------
  const LOGIN_ENDPOINT = `${ backendUrl }/api/token/create/`;
  const COOKIE_EXPIRES_DAYS = store.getters.getCookieExpiresDays;
  //------------------------------
  const form = ref(null);
  const errorMessage = ref('');
  //------------------------------
  onMounted(() => {
    window.addEventListener('keydown', onEnterKeyPress);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('keydown', onEnterKeyPress);
  });
  //------------------------------
  //Статус отправки данных
  const get_isLoading = computed(() => store.state.AuthorizationSystem.isLoading)
  //------------------------------
  //Открыть стартовую секцию регистрации
  const toOpenSignupSection = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.START_SIGNUP);
  }
  //Открыть секцию 'Забыли пароль'
  const toOpenForgotPassSection = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.FORGOT_PASS);
  }
  //Запуск авторизации
  const toLogin = async () => {
    if(get_isLoading.value) return;
    errorMessage.value = '';
    toChangeLoadingFlag(true);
    try {
      const response = await fetch(LOGIN_ENDPOINT, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(toPrepareData())
      });
      if (!response.ok) {
        if (response.status === 400) {
          const errorData = await response.json();
          if (errorData.detail) {
            throw new Error(errorData.detail);
          }
          if (errorData.error) {
            throw new Error(errorData.error);
          }
        }
        throw new Error(`Ошибка сети: ${response.status} - ${response.statusText}`);
      }
      const data = await response.json();
      await store.dispatch('saveAccessToken', data.access);
      // setCookie('refresh_token', data.refresh, COOKIE_EXPIRES_DAYS);
      toChangeLoadingFlag(false);
      toCloseWidget();
      updateAuthStatus();
      toInitUserData();
      toRestartInfonoisePage();
      toCallSuccessMessage();
      await router.push('/');
    } catch(error){
      toChangeLoadingFlag(false);
      console.error('Ошибка при попытке входа:', error);
      errorMessage.value = error.message;
    }
  }
  //Подготовить данные для отправки на сервер
  const toPrepareData = () => {
    const formObj = new FormData(form.value);
    const dataForServer = {};
    for (const [key, value] of formObj.entries()){
      dataForServer[key] = value;
    }
    dataForServer['remember'] = dataForServer['remember'] ? true : false;
    return dataForServer;
  }
  //Инициализировать процесс получения данных пользователя
  const toInitUserData = () => {
    store.dispatch('UserSystem/toGetUserData');
  }
  //Отметить процесс отправки данных на сервер
  const toChangeLoadingFlag = (status) => store.commit('AuthorizationSystem/toChangeLoadingFlag', status);
  //Закрыть попап с авторизацией
  const toCloseWidget = () => store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.auth);
  //Отметить в системе, что пользователь авторизирован
  const updateAuthStatus = () => store.commit('UserSystem/toChangeAuthenticatedStatus', true);
  //Вызвать сообщение об успешном входе в аккаунт
  const toCallSuccessMessage = () => {
    const text = 'Вы успешно авторизовались в системе';
    const color = 'green';
    store.dispatch('OverlayManagerSystem/addMessage', { text, color });
  }
  //Перезагрузить инфошум
  const toRestartInfonoisePage = () => {
    store.dispatch('ContentSystem/toGetFirstPagePosts');
  }
  //Глобальный обработчик для Enter
  const onEnterKeyPress = (e) => {
    const key = e.key || e.keyCode;
    if (key === 'Enter' || key === 13) {
      e.preventDefault();
      toLogin();
    }
  };
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>
